import { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { getAuditTrailByid, getAuditTrailByPreview } from '../../../../redux/auditTrailSlice';
import { processContentData } from '../utils/previewUtils';

/**
 * Custom hook for fetching and processing audit trail preview data
 * @param {string} audit_trail_id - Audit trail ID from route params
 * @param {Function} getDataFromVersionContent - Function to extract data from version_content
 * @returns {Object} { audit_trail_data, contentData, loading, error }
 */
export function useAuditTrailPreview(audit_trail_id, getDataFromVersionContent) {
  const dispatch = useDispatch();
  const [audit_trail_data, setAuditData] = useState({});
  const [loaded_version_content, setLoadedVersionContent] = useState({});
  const [contentData, setContentData] = useState([]);
  const [isContentLoaded, setIsContentLoaded] = useState(false);
  const [error, setError] = useState(null);
  const getDataRef = useRef(getDataFromVersionContent);

  // Keep ref updated
  useEffect(() => {
    getDataRef.current = getDataFromVersionContent;
  }, [getDataFromVersionContent]);

  // Fetch audit trail data
  useEffect(() => {
    (async () => {
      try {
        const resp = await dispatch(getAuditTrailByid({ id: audit_trail_id }));
        setAuditData(resp.payload.results);
        setError(null);
      } catch (err) {
        console.error('Error fetching audit trail:', err);
        setError('Failed to fetch audit trail data');
      }
    })();
  }, [dispatch, audit_trail_id]);

  // Fetch and process preview content
  useEffect(() => {
    (async () => {
      if (!audit_trail_data.version_content || isContentLoaded) {
        return;
      }

      let rawData = await getDataRef.current(audit_trail_data.version_content,audit_trail_data.new_content_snapshot);

      if(audit_trail_data.version_content.status_changes_preview){
        setLoadedVersionContent({...rawData})
        rawData = rawData.revisionNodes;
      }
      setContentData(rawData);
      setIsContentLoaded(true);
      setError(null);

    })();
  }, [dispatch, audit_trail_data, isContentLoaded]);

  return {
    audit_trail_data:{
      ...audit_trail_data,
      version_content:{
        ...audit_trail_data.version_content,
        ...loaded_version_content
      }
    },
    contentData,
    isContentLoaded,
    error
  };
}

